import { getAll } from '@/api/tiers';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { TIERS_SOUS_TYPE_CONFRERE, TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';

export default async function getAllConfrere(filtres) {
  const query = {
    sousType: [TIERS_SOUS_TYPE_CONFRERE],
    type: TIERS_TYPE_FOURNISSEUR,
  };
  const listeConfreres = (await getAll({
    limit: NO_PAGINATION,
    query: { ...query, ...filtres },
  })).data.result.items;
  return listeConfreres;
}
